<template>
  <v-list :color="color" class="py-0">
    <template v-if="useDishOrder">
      <h-items
        v-for="dishOrder in dishOrders"
        :key="dishOrder.id"
        :contents="contents.filter(o => o.dishOrder == dishOrder.order)"
        :subheader="dishOrder.name"
        :disabled="disabled"
        :closed="closed"
        @open="$emit('open', $event)"
      />
    </template>
    <h-items
      v-else
      :contents="contents"
      :disabled="disabled"
      :closed="closed"
      @open="$emit('open', $event)"
    />
  </v-list>
</template>

<script>
  import HItems from './Items'

  export default {
    components: {
      HItems,
    },

    props: {
      contents: {
        required: true,
        type: Array,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      closed: {
        required: false,
        type: Boolean,
        default: false,
      },
      color: {
        required: false,
        type: String,
      },
      useDishOrder: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      dishOrders () {
        return this.$store.getters['catalog/dishOrders']
      },
    },
  }
</script>
